export const open = (url, inNewTab) => {
  if (typeof window !== "undefined" && window && window.open)
    window.open(url, inNewTab ? "_blank" : null)
}
